import { client } from '../client';

// Keep this the only copy. Its callers are split between the `@brands/` alias
// (SignIn, ExistingAccount) and relative paths (SignUp, getBrowserLocationState),
// so a brand-level copy would be picked up by the first pair and ignored by the
// second — both live at once, silently diverging on the next edit. There is no
// brand variance here to justify that risk; this is one API call.

// `country` is ISO 3166-1 alpha-3 ("USA"). It is optional because a response
// from an API that predates the field must not be read as "not in the US".
export type GeocodeStateResponse = { state: string; country?: string | null };

export const getStateFromGeocode = async (lat: number, lng: number): Promise<GeocodeStateResponse> => {
  const { data } = await client.get<GeocodeStateResponse>(`/geolocation/state?lat=${lat}&lng=${lng}`);

  return data;
};
